<script>
    import Title from "../components/Title.svelte";
    import SmallTitle from "../components/SmallTitle.svelte";
    import Background from "../components/Background.svelte";
    import QrCode from "../components/QrCode.svelte";
</script>

<section id="channel-info">
    <Background>
        <img class="bg" src="images/index/channel-bg.svg">
    </Background>
    <Title title="『考研红宝书』微信公众号" hint="每日精选考研必读 专注考研资讯与学习资料" />
    <div class="content">
        <div class="phone-screen">
            <img src="images/index/公众号图例.png"/>
        </div>
        <div>
            <div style="margin-top: 5px">
                <SmallTitle title="每日一句" hint="长难句文字+音频解析 助你每日精进" align="left" />
            </div>
            <div style="margin-top: 21px">
                <SmallTitle title="双语阅读" hint="精选文章双语长文 写作必读" align="left"/>
            </div>

            <div class="qr-block">
                <QrCode qrImage="images/index/微信公众号二维码.jpg" hint="扫码关注" moreHint="『考研红宝书』微信公众号" />
            </div>
        </div>
    </div>
</section>

<style>
    #channel-info {
        margin-top: 132px;
    }

    .bg {
        position: absolute;
        top: 65px;
        width: 375px;
    }

    .phone-screen img {
        width: 156px;
    }

    .content {
        margin-top: 42px;
        display: grid;
        align-items: center;
        justify-content: center;
        grid-template-columns: repeat(auto-fit, 160px);
    }
    .qr-block {
        margin-top: 14px;
    }
</style>
